export function normalizeSsCode(code) {
  return String(code || '').trim().replace(/\//g, '.');
}

export const IQP_GRADE_OPTIONS = ['Registered', 'A', 'B', 'C'];

export function toDateInputValue(iso) {
  if (!iso) return '';
  const m = String(iso).match(/^(\d{4}-\d{2}-\d{2})/);
  return m ? m[1] : '';
}

export function groupSsCodesForPicker(displaySsCodes) {
  if (!displaySsCodes?.length) return [];
  const grouped = {};
  displaySsCodes.forEach((ss) => {
    const mainNum = ss.code.match(/SS\s*(\d+)/)?.[1] || '0';
    if (!grouped[mainNum]) grouped[mainNum] = [];
    grouped[mainNum].push(ss);
  });
  const result = [];
  for (let i = 1; i <= 16; i++) {
    const num = String(i);
    if (grouped[num]) {
      result.push({ mainNum: num, label: `SS ${num}`, codes: grouped[num] });
    }
  }
  Object.keys(grouped).forEach((num) => {
    if (Number(num) > 16 || Number(num) < 1) {
      result.push({ mainNum: num, label: `SS ${num}`, codes: grouped[num] });
    }
  });
  return result;
}
